import React, { Component } from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { connect } from "react-redux";
import { LocationFlag, InventoryStatusCell } from "MODULES/shared/components";
import { INVENTORIES } from "MODULES/inventories/constants";
import { searchInventories as search } from "MODULES/parts/actions";
import { alphaMonthYear } from "LIB/formatters/date";
import { dollars } from "LIB/formatters/currency";

export class SelectInventoryTable extends Component {
  static propTypes = {
    part: PropTypes.shape({
      id: PropTypes.number.isRequired
    }),
    onInventorySelected: PropTypes.func.isRequired,
    searchInventories: PropTypes.func.isRequired,
    filter: PropTypes.shape({}),
    selectedInventory: PropTypes.shape({})
  };

  state = {
    inventories: []
  };

  componentWillMount() {
    if (this.props.part) {
      this.setInventory(this.props.part.id);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.part && nextProps.part !== this.props.part) {
      this.setInventory(nextProps.part.id, false);
    }
  }

  setInventory = (partId, addRecord = true) => {
    const { searchInventories, filter, selectedInventory = {} } = this.props;
    searchInventories(partId, filter).then(resp => {
      if (selectedInventory.id && addRecord) {
        const containsInv = resp.some(inv => inv.id === selectedInventory.id);
        if (!containsInv) {
          resp.unshift(selectedInventory);
        }
      }
      this.setState({ inventories: resp });
    });
  };

  renderRow = (inventory, i) => (
    <tr key={i}>
      <td>{i + 1}</td>
      <InventoryStatusCell inventory={inventory}>
        <Field
          component="input"
          type="radio"
          name="inventory_id"
          className="radio-inline"
          value={inventory.id.toString()}
          onChange={() => this.props.onInventorySelected(inventory)}
        />
      </InventoryStatusCell>
      <td>{inventory.serial_number}</td>
      <td>
        {inventory.condition &&
          INVENTORIES.condition[inventory.condition].abbrev}
      </td>
      <td>{inventory.quantity}</td>
      <td>{alphaMonthYear(inventory.tag_date)}</td>
      <td className="text-center">
        <LocationFlag location={inventory.store_location_id} />
      </td>
      <td className="text-right">
        {inventory.cost_per_unit && dollars(inventory.cost_per_unit)}
      </td>
      <td className="text-right">
        {inventory.exchange_srp && dollars(inventory.exchange_srp)}
      </td>
      <td className="text-right">
        {inventory.suggested_retail && dollars(inventory.suggested_retail)}
      </td>
    </tr>
  );

  render() {
    return (
      <table className="table table-striped table-hover table-numbered">
        <thead>
          <tr>
            <th />
            <th />
            <th>Serial Number</th>
            <th>CD</th>
            <th>QTY</th>
            <th>Tag Date</th>
            <th className="text-center">Store Location</th>
            <th className="text-right">Cost/Unit</th>
            <th className="text-right">Exch SRP</th>
            <th className="text-right">SRP</th>
          </tr>
        </thead>
        <tbody>
          {this.state.inventories.map(this.renderRow)}
          <tr>
            <td />
            <td className="text-center">
              <Field
                component="input"
                type="radio"
                name="inventory_id"
                className="radio-inline"
                value=""
                onChange={() => this.props.onInventorySelected(null)}
              />
            </td>
            <td
              colSpan="8"
              style={{ marginBottom: "2px", verticalAlign: "baseline" }}
            >
              Don&apos;t quote from a specific inventory item
            </td>
          </tr>
        </tbody>
      </table>
    );
  }
}

export default connect(undefined, dispatch => ({
  searchInventories: (partId, filter) => dispatch(search(partId, filter))
}))(SelectInventoryTable);



// WEBPACK FOOTER //
// ./app/modules/inventories/components/shared/SelectInventoryTable.jsx